import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Wrench, History, Gauge, LayoutGrid, Sun, Moon } from "lucide-react";
import { Button } from "./ui/button";
import { useTheme } from "../lib/theme";

export const Header = ({ onOpenHistory }) => {
  const location = useLocation();
  const isCategories = location.pathname === "/categories";
  const { theme, toggle } = useTheme();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-slate-800/70 bg-slate-950/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <div className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-500 to-cyan-700 shadow-[0_0_25px_rgba(6,182,212,0.35)] transition-transform group-hover:rotate-6">
            <Wrench className="h-5 w-5 text-slate-950" strokeWidth={2.5} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-heading text-xl font-extrabold tracking-tight text-slate-50">
              Autopièce<span className="text-cyan-400"> Malin</span>
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
              Comparateur Pièces · Auto / Moto / Poids lourd
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <Link
            to="/"
            data-testid="nav-home"
            className={`text-sm font-medium transition ${location.pathname === "/" ? "text-cyan-300" : "text-slate-300 hover:text-cyan-400"}`}
          >
            Accueil
          </Link>
          <Link
            to="/categories"
            data-testid="nav-categories"
            className={`inline-flex items-center gap-1.5 text-sm font-medium transition ${isCategories ? "text-cyan-300" : "text-slate-300 hover:text-cyan-400"}`}
          >
            <LayoutGrid className="h-3.5 w-3.5" />
            Catégories
          </Link>
          <a
            href="/#how"
            data-testid="nav-how"
            className="text-sm font-medium text-slate-300 transition hover:text-cyan-400"
          >
            Comment ça marche
          </a>
          <Link
            to="/blog"
            data-testid="nav-blog"
            className="text-sm font-medium text-slate-300 transition hover:text-cyan-400"
          >
            Blog
          </Link>
          <a
            href="/#trust"
            data-testid="nav-trust"
            className="text-sm font-medium text-slate-300 transition hover:text-cyan-400"
          >
            Garanties
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/categories"
            data-testid="nav-categories-mobile"
            className="inline-flex md:hidden items-center justify-center rounded-md border border-slate-700 bg-slate-900/70 p-2 text-slate-300 hover:border-cyan-500/50 hover:text-cyan-300"
            aria-label="Catégories"
          >
            <LayoutGrid className="h-4 w-4" />
          </Link>
          <Button
            data-testid="theme-toggle-button"
            variant="outline"
            size="sm"
            onClick={toggle}
            aria-label={theme === "dark" ? "Activer le mode clair" : "Activer le mode sombre"}
            className="h-9 w-9 p-0 border-slate-700 bg-slate-900/70 text-slate-200 hover:border-cyan-500/50 hover:bg-slate-800 hover:text-cyan-300"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </Button>
          <Button
            data-testid="open-history-button"
            variant="outline"
            size="sm"
            onClick={onOpenHistory}
            className="gap-2 border-slate-700 bg-slate-900/70 text-slate-200 hover:border-cyan-500/50 hover:bg-slate-800 hover:text-cyan-300"
          >
            <History className="h-4 w-4" />
            <span className="hidden sm:inline">Historique</span>
          </Button>
          <div
            data-testid="live-badge"
            className="hidden items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 lg:flex"
          >
            <Gauge className="h-3.5 w-3.5 text-emerald-400" />
            <span className="font-mono text-[11px] uppercase tracking-widest text-emerald-300">
              IA en ligne
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

